import { Box, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { getRegionBySlug } from 'src/pages/CareerHistory/CareerHistorySlice';

export default function Footer() {
  const { rg_name, cg_name } = useParams();
  const regions = useSelector((state) => state.careerHistory);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const clgDetails = useSelector((state) => state.mainLayout.collegeDetails);
  const location = useLocation();
  useEffect(() => {
    if (rg_name) {
      Cookies.set('url-slug', rg_name);
    }
  }, [rg_name]);
  const dispatch = useDispatch();

  useEffect(() => {
    // College routes (e.g. the widget) have no region in the URL; the college's region is used instead
    if (!rg_name) return;
    setLoading(true);
    dispatch(getRegionBySlug(rg_name));
  }, [rg_name, dispatch]);

  useEffect(() => {
    if (rg_name && regions?.regions) {
      setData(regions?.regions);
      if (!isEmpty(data)) {
        setLoading(false);
      }
    }
  }, [regions?.regions, data, rg_name]);

  useEffect(() => {
    if (cg_name) {
      setData(clgDetails?.region);
    }
  }, [cg_name, clgDetails?.region]);

  const hideLogos =
    location.pathname.endsWith('/sign-in') ||
    location.pathname.endsWith('/sign-up') ||
    location.pathname.endsWith('/forgotpassword');

  const partnerLogos = useMemo(() => {
    const baseLogos = [...(data?.partnerLogos || [])];

    if (cg_name && clgDetails?.logo) {
      baseLogos.unshift(clgDetails.logo);
    }

    return baseLogos;
  }, [data?.partnerLogos, cg_name, clgDetails?.logo]);
  return (
    <footer>
      {/* <Box className='logo'>
        <Typography variant='medium'>powered by</Typography>
        <img src={Logo} alt="Logo" />
      </Box> */}

      {!hideLogos && partnerLogos.length > 0 && (
        <Box
          sx={{
            width: '100%',
            // bgcolor: '#f8f8f8',
            py: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 4,
            flexWrap: 'wrap',
            borderTop: '1px solid #eee',
            px: 10,
          }}
        >
          {partnerLogos.map((partnerLogo, idx) => (
            <img
              key={idx}
              src={partnerLogo}
              alt={`Partner Logo ${idx + 1}`}
              style={{
                height: 100,
                objectFit: 'contain',
                // background: '#fff',
                borderRadius: 6,
                padding: 6,
              }}
            />
          ))}
        </Box>
      )}
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ display: { xs: 'none', sm: 'block' } }}>
          © 2025 ThinkSkills – All rights reserved |{' '}
          <a
            href="/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'black' || '#1976d2',
              textDecoration: 'underline',
              textDecorationLine: 'none',
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#1976d2';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'black';
            }}
          >
            Terms and Conditions
          </a>{' '}
          |{' '}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'black' || '#1976d2',
              textDecoration: 'underline',
              textDecorationLine: 'none',
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#1976d2';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'black';
            }}
          >
            Privacy Policy
          </a>
          {' '}
          |{' '}
          <a
            href="/website-accesibility-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'black' || '#1976d2',
              textDecoration: 'underline',
              textDecorationLine: 'none',
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#1976d2';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'black';
            }}
          >
            Accessibility Statement
          </a>
        </Typography>
        
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            © 2025 ThinkSkills – All rights reserved
          </Typography>
          <Typography variant="body1">
            <a
              href="/terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'black' || '#1976d2',
                textDecoration: 'underline',
                textDecorationLine: 'none',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#1976d2';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'black';
              }}
            >
              Terms of Service
            </a>{' '}
            |{' '}
            <a
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'black' || '#1976d2',
                textDecoration: 'underline',
                textDecorationLine: 'none',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#1976d2';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'black';
              }}
            >
              Privacy Policy
            </a>
            {' '}
            |{' '}
            <a
              href="/website-accesibility-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'black' || '#1976d2',
                textDecoration: 'underline',
                textDecorationLine: 'none',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#1976d2';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'black';
              }}
            >
              Accessibility Statement
            </a>
          </Typography>
        </Box>
      </Box>
    </footer>
  );
}
